import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import * as Yup from 'yup';
import { RulesetResult } from '../../business/rules';
import { PropertyOwnerRelatedToBusinessRuleset } from '../../business/ruleset/solar_property';
import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';

const { systemPropertyOwnerRelatedToBorrower } = loanFormModel.formField;

export class PropertyOwnerRelatedToBorrowerValidation
  implements ValidationSchema
{
  public name: string = systemPropertyOwnerRelatedToBorrower.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(schema: Yup.StringSchema, context: any) {
    if (!context.from) return schema;
    const application = context.from[1].value;
    const parent = context.parent;
    const index = application.principals.findIndex(
      (principal) =>
        principal.relationship == RELATED_PARTY_RELATIONSHIP.LANDLORD &&
        principal.id === parent.id
    );
    const result =
      PropertyOwnerRelatedToBusinessRuleset.setIndex(index).evaluate(
        application
      );

    if (result & RulesetResult.REQUIRED)
      return schema.required('This field is required');
    return schema;
  }
}
export default new Validation(new PropertyOwnerRelatedToBorrowerValidation());
